/* global axios */
import ApiClient from './ApiClient';

class UploadApi extends ApiClient {
  constructor() {
    super('upload', { accountScoped: true });
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('attachment', file);

    return axios.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  uploadFromUrl(externalUrl) {
    return axios.post(this.url, {
      external_url: externalUrl,
    });
  }
}

export default new UploadApi();
